import Store01 from './01.jpg';
import Store02 from './02.jpg';
import Store03 from './03.jpg';
import Store04 from './04.jpg';
import Store05 from './05.jpg';
import Store06 from './06.jpg';
import Store07 from './07.jpg';
import Store08 from './08.jpg';
import Store09 from './09.jpg';
import Store10 from './10.jpg';
import Store11 from './11.jpg';
import Store12 from './12.jpg';
import Store13 from './13.jpg';
import Store14 from './14.jpg';

export { Store01, Store02, Store03, Store04, Store05, Store06, Store07, Store08, Store09, Store10, Store11, Store12, Store13, Store14 };
